import {Component, effect, input, model} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {IconComponent} from '../icon/icon.component';
import {NgClass} from '@angular/common';
import {BreakpointService} from '../../service/breakpoint.service';

@Component({
  selector: 'ucs-sidebar-template',
  imports: [
    IconComponent,
    TranslatePipe,
    NgClass
  ],
  templateUrl: './sidebar-template.component.html',
  styleUrl: './sidebar-template.component.scss'
})
export class SidebarTemplateComponent {
  showSidebar = model(true);
  doJumpToTopOnToggle = input(false);
  scrollPosition: number = 0;

  constructor(private readonly breakpoint: BreakpointService) {
    effect(() => {
      this.showSidebar.set(this.breakpoint.isMd() || this.breakpoint.isLg() || this.breakpoint.isXl());
      if (!this.breakpoint.isMobile()) {
        document.getElementsByTagName('body')[0].style.overflow = '';
      }
    });
  }

  toggleSidebar() {
    this.showSidebar.set(!this.showSidebar());
    const body = document.getElementsByTagName('body')[0];
    if (this.showSidebar() && this.breakpoint.isMobile()) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = '';
    }

    if (this.doJumpToTopOnToggle()) {
      if (this.showSidebar()) {
        window.scrollTo(0, this.scrollPosition);
      } else {
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo(0, 0);
      }
    }
  }
}
